const SHEET_URL =
  'https://docs.google.com/spreadsheets/d/1ASH-Zo4qGRg8pfXvIP0SrHdKaXK7kEFKyG-7Hg0t93Q/export?format=csv&gid=1197455181';

function parseCSVLine(line) {
  const result = [];
  let current = '';
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (ch === '"') {
      inQuotes = !inQuotes;
    } else if (ch === ',' && !inQuotes) {
      result.push(current);
      current = '';
    } else {
      current += ch;
    }
  }
  result.push(current);
  return result;
}

// Cache de config dos desafios (descrição da página)
var _configDesafios = {};

export function getConfigDesafios() {
  return _configDesafios;
}

export async function buscarDesafiosDaPlanilha() {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 6000);
    const res = await fetch(SHEET_URL, { cache: 'no-store', signal: controller.signal });
    clearTimeout(timeoutId);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const text = await res.text();
    const lines = text.trim().split('\n');
    if (lines.length < 2) return [];
    const headers = parseCSVLine(lines[0]).map(h => h.trim());
    const todos = lines.slice(1).map(line => {
      const cols = parseCSVLine(line);
      const obj = {};
      headers.forEach((h, i) => {
        obj[h] = (cols[i] || '').trim();
      });
      // Extrair prompts em sub-objeto
      obj.prompts = {};
      for (let d = 1; d <= 30; d++) {
        const key = `prompt_dia_${d}`;
        if (obj[key]) {
          obj.prompts[key] = obj[key];
          delete obj[key];
        }
      }
      obj.duracao = parseInt(obj.duracao) || 7;
      // Formatar data de início se existir
      if (obj.data_inicio) {
        try {
          const [dia, mes, ano] = obj.data_inicio.split('/');
          const d = new Date(`${ano}-${mes}-${dia}`);
          obj.data_inicio_formatada = d.toLocaleDateString('pt-BR', { day: 'numeric', month: 'long' });
        } catch {
          obj.data_inicio_formatada = null;
        }
      }
      // Normalizar opcoes do parâmetro para array
      if (obj.parametro_opcoes) {
        obj.parametro_opcoes_array = obj.parametro_opcoes
          .split(',')
          .map(o => o.trim())
          .filter(Boolean);
      } else {
        obj.parametro_opcoes_array = [];
      }
      return obj;
    });

    // Separa linhas de config (nome = "_config") das linhas de desafio
    todos.forEach(function(obj) {
      if ((obj.nome || '').trim() === '_config') {
        if (obj.descricao) _configDesafios.descricao = obj.descricao;
      }
    });

    return todos.filter(function(obj) {
      return (obj.nome || '').trim() !== '_config';
    });
  } catch (err) {
    console.error('[desafios] erro ao buscar planilha:', err);
    return [];
  }
}

// 365 prompts de reflexão — um por dia do ano, sem repetição
var PROMPTS_REFLEXAO = [
  // ── Presença & Observação ─────────────────────────────────────────────────
  'O que você ainda não disse que precisava dizer?',
  'Qual foi o momento em que você se sentiu mais viva(o) hoje?',
  'O que você está evitando pensar?',
  'Como você reagiu quando as coisas não saíram como planejado?',
  'O que o silêncio do dia te revelou?',
  'Qual pensamento você gostaria de poder soltar agora?',
  'O que aconteceu hoje que você ainda está processando?',
  'Que tipo de energia você levou para os seus relacionamentos hoje?',
  'O que você notou no seu corpo ao longo do dia?',
  'Qual foi a parte mais difícil do dia — e o que ela te ensinou?',
  'O que te tirou do momento presente hoje?',
  'Qual foi o primeiro pensamento que você teve ao acordar?',
  'O que você fez hoje de forma automática que poderia ter sido mais consciente?',
  'Qual parte do dia você gostaria de reviver?',
  'O que você observou ao seu redor que normalmente ignora?',
  // ── Emoções ───────────────────────────────────────────────────────────────
  'Qual emoção você tentou esconder hoje?',
  'O que você sentiu, mas não conseguiu nomear?',
  'Quando você se sentiu mais em paz hoje?',
  'Teve algum momento de tristeza hoje? O que estava por trás dela?',
  'O que te irritou hoje e o que isso diz sobre você?',
  'Como estava a sua paciência hoje?',
  'Qual sentimento você carregou por mais tempo hoje?',
  'O que você sentiu ao ajudar alguém hoje?',
  'Teve algum momento de alegria pura hoje? Qual foi?',
  'O que sua raiva estava tentando te proteger hoje?',
  // ── Relacionamentos ───────────────────────────────────────────────────────
  'Quem você pensou hoje sem conseguir parar?',
  'Qual relacionamento está pedindo mais atenção da sua parte?',
  'O que você deu para alguém hoje que não era material?',
  'Teve alguém que te surpreendeu positivamente hoje?',
  'O que você aprendeu sobre si mesma(o) em um relacionamento recente?',
  'Como você se sentiu sendo vista(o) por alguém hoje?',
  'Existe alguém de quem você está se afastando? Por quê?',
  'O que você precisa comunicar, mas ainda não achou as palavras?',
  'Como você poderia ter sido mais presente para alguém hoje?',
  'Quem em sua vida te faz sentir mais você mesma(o)?',
  // ── Identidade & Valores ──────────────────────────────────────────────────
  'O que você defendeu hoje, mesmo que discretamente?',
  'Existe alguma crença sua que você está questionando?',
  'O que você faria diferente se não tivesse medo do julgamento alheio?',
  'Qual valor seu foi colocado à prova hoje?',
  'O que as suas escolhas de hoje dizem sobre quem você está se tornando?',
  'Existe uma versão de você que você deixou para trás? Faz falta?',
  'O que você sabe sobre si mesma(o) que poucas pessoas sabem?',
  'Como você se descreveria para alguém que nunca te conheceu?',
  'O que você mais admira em si mesma(o) quando está no seu melhor?',
  'Existe algo em você que você ainda está aprendendo a aceitar?',
  // ── Hábitos & Padrões ─────────────────────────────────────────────────────
  'Qual hábito te serviu bem hoje?',
  'O que você fez hoje que vai te custar energia amanhã?',
  'Qual rotina você está mantendo por inércia, não por escolha?',
  'O que você começa toda semana com intenção mas não sustenta?',
  'Qual é a história que você conta para si mesma(o) quando desiste?',
  'O que mudaria na sua vida se você fizesse isso por 30 dias?',
  'Qual pequeno hábito você quer cultivar a partir de amanhã?',
  'O que você já tentou mudar mais de três vezes? O que isso te diz?',
  'Qual parte da sua rotina te energiza mais?',
  'O que você fez hoje por puro prazer, sem propósito?',
  // ── Medos & Desafios ──────────────────────────────────────────────────────
  'O que você temeu hoje que provavelmente não vai acontecer?',
  'Qual é o pior cenário que você está imaginando — e qual a probabilidade real?',
  'O que você faria agora se soubesse que ia conseguir?',
  'Qual desafio está te fazendo crescer, mesmo sendo difícil?',
  'O que você está postergando porque parece grande demais?',
  'Qual medo você está começando a superar, mesmo que devagar?',
  'O que te impede de ser mais vulnerável com as pessoas que ama?',
  'Existe algo que você quer muito, mas tem medo de querer?',
  'Você sobreviveria ao seu maior medo se ele se realizasse?',
  'Qual coragem pequena você pode exercer amanhã?',
  // ── Gratidão & Apreciação ─────────────────────────────────────────────────
  'O que você tem hoje que não tinha há um ano?',
  'Qual inconveniência do dia foi, na verdade, um privilégio?',
  'O que você está recebendo que está levando tempo para perceber?',
  'Pelo que você está grata(o) que raramente verbaliza?',
  'Qual pessoa em sua vida merece mais reconhecimento da sua parte?',
  'O que o seu corpo fez hoje que você pode agradecer?',
  'Qual detalhe bonito do dia você quase deixou passar?',
  'O que na sua rotina, se fosse tirado, faria muita falta?',
  'Existe algo que você costumava reclamar e hoje é diferente?',
  'O que você tem em abundância que outra pessoa gostaria de ter?',
  // ── Corpo & Autoconsciência Física ────────────────────────────────────────
  'Como o seu corpo expressou as suas emoções hoje?',
  'O que você precisava fazer pelo seu corpo hoje e não fez?',
  'Em que momento do dia você se sentiu mais disposta(o)?',
  'O que o cansaço de hoje está te pedindo?',
  'Você deu ao seu corpo o que ele precisava para descansar?',
  'Como a sua alimentação refletiu o seu estado emocional hoje?',
  'Que sensação física ficou com você hoje — tensão, leveza, calor?',
  'O que o seu corpo sabe sobre você que sua mente ainda não aceitou?',
  'Onde no corpo você carrega a sua tensão? Hoje foi diferente?',
  'O que você fez hoje que foi um gesto de cuidado com o seu corpo?',
  // ── Criatividade & Expressão ──────────────────────────────────────────────
  'O que você criou hoje, mesmo que pequeno?',
  'Teve um momento em que você se expressou de forma autêntica?',
  'O que você gostaria de ter dito, escrito ou criado hoje?',
  'Qual ideia ficou rondando sua cabeça sem sair?',
  'O que te inspira agora, neste momento?',
  'Como você expressaria o seu dia em uma cor?',
  'Existe uma história que só você poderia contar?',
  'O que você criaria se soubesse que ninguém iria julgar?',
  'Quando foi a última vez que você se surpreendeu com a sua própria criatividade?',
  'O que está esperando para sair de dentro de você?',
  // ── Propósito & Significado ───────────────────────────────────────────────
  'O que te fez sentir que o dia valeu a pena?',
  'Qual foi a parte do dia que teve mais significado para você?',
  'O que você fez hoje que contribuiu, mesmo que sutilmente, para algo maior?',
  'Qual é o propósito por trás do que você mais investe seu tempo?',
  'O que você quer que as pessoas sintam quando estão perto de você?',
  'O que você está construindo, devagar, dia após dia?',
  'Qual legado você quer deixar — não no futuro distante, mas agora?',
  'O que te faz sentir que você está no lugar certo?',
  'Existe algo que você faz que te faz perder a noção do tempo?',
  'O que você faz que só você faz do jeito que você faz?',
  // ── Mudança & Crescimento ─────────────────────────────────────────────────
  'O que mudou em você nos últimos 30 dias?',
  'Qual versão de si mesma(o) você está deixando para trás?',
  'O que você aprendeu recentemente que mudou a forma como você vê algo?',
  'Qual mudança pequena está fazendo uma grande diferença?',
  'O que você resistia antes e hoje aceita com mais leveza?',
  'Como você está diferente de quem era há seis meses?',
  'Qual crença antiga você está desconstruindo?',
  'O que você precisou perder para encontrar algo melhor?',
  'Qual transformação está acontecendo em você, mesmo que devagar?',
  'O que você está aprendendo sobre si mesma(o) que te surpreende?',
  // ── Descanso & Autocuidado ────────────────────────────────────────────────
  'O que você fez hoje para renovar a sua energia?',
  'Qual momento do dia foi o seu descanso — mesmo que breve?',
  'O que você está negligenciando em nome da produtividade?',
  'Como você se trata quando erra — com dureza ou com compaixão?',
  'O que você precisaria soltar para dormir mais leve hoje?',
  'Qual é a sua forma favorita de se reconectar consigo mesma(o)?',
  'O que você fez por puro prazer, sem culpa, hoje?',
  'Existe algo que te recarrega que você está deixando de lado?',
  'Como você cuida de si mesma(o) quando está sobrecarregada(o)?',
  'O que significa, para você, descansar de verdade?',
  // ── Trabalho & Propósito Profissional ─────────────────────────────────────
  'O que você realizou hoje que merece reconhecimento?',
  'Qual tarefa do dia te deu mais satisfação ao concluir?',
  'O que estava ocupando seu tempo mas não estava avançando nada?',
  'Como você se sentiu no seu trabalho hoje?',
  'O que você faria diferente amanhã para se sentir melhor?',
  'Existe algo na sua rotina que está sugando sua alegria?',
  'O que você aprendeu hoje que vai além da sua função?',
  'Como você poderia trazer mais significado para o que faz?',
  'O que você está construindo que te orgulha?',
  'Qual limite você precisaria colocar para se sentir melhor?',
  // ── Sonhos & Aspirações ───────────────────────────────────────────────────
  'O que você sonhou fazer que ainda não começou?',
  'Se você soubesse que ia dar certo, o que tentaria amanhã?',
  'Qual sonho você deixou de lado que ainda faz seu coração acelerar?',
  'O que você imagina para si mesma(o) daqui a cinco anos?',
  'Existe algo que você deseja profundamente mas tem vergonha de admitir?',
  'O que você precisa acreditar sobre si mesma(o) para ir atrás do que quer?',
  'Qual passo pequeno você pode dar amanhã na direção do que sonha?',
  'O que te distancia dos seus sonhos — circunstâncias ou escolhas?',
  'Existe alguém vivendo o que você quer? O que pode aprender com essa pessoa?',
  'O que você ainda não tentou porque tem medo de querer muito?',
  // ── Passado & Futuro ──────────────────────────────────────────────────────
  'O que do passado você ainda está carregando que não precisa mais?',
  'Qual memória de hoje você quer guardar?',
  'O que você diria para a versão de você de cinco anos atrás?',
  'O que o futuro você gostaria que você soubesse hoje?',
  'Existe algo que você se arrepende de não ter feito mais cedo — e pode fazer agora?',
  'Como o passado está influenciando as suas decisões de hoje?',
  'O que você está construindo agora que vai agradecer no futuro?',
  'Qual parte do seu passado você ainda não integrou completamente?',
  'O que você está deixando para "um dia" que poderia começar hoje?',
  'Qual é a visão do futuro que mais te anima?',
  // ── Comunidade & Pertencimento ────────────────────────────────────────────
  'O que você recebeu da sua comunidade hoje, mesmo que simbolicamente?',
  'Como você contribuiu para o bem-estar de alguém hoje?',
  'O que você pode oferecer que ninguém te pediu, mas que faria diferença?',
  'Existe alguém na sua vida que precisa de você agora?',
  'Como você se sentiu fazendo parte de algo maior hoje?',
  'O que você aprendeu ao observar alguém diferente de você?',
  'Como você poderia ser mais generosa(o) com o seu tempo?',
  'O que faz você se sentir que pertence a um lugar ou grupo?',
  'Como a sua presença afetou o ambiente que você frequentou hoje?',
  'O que você gostaria de dar para o mundo que só você pode dar?',
  // ── Intuição & Instinto ───────────────────────────────────────────────────
  'Qual foi o seu primeiro instinto sobre algo hoje — você seguiu?',
  'O que o seu corpo sinalizou antes da sua mente processar?',
  'Existe algo que você já sabe, mas está esperando uma prova?',
  'Qual voz interna você precisa escutar mais?',
  'O que sua intuição está dizendo que sua lógica está tentando calar?',
  'Quando foi a última vez que você confiou plenamente em si mesma(o)?',
  'O que você sabe que é certo, mas ainda não agiu?',
  'Qual decisão você tomou hoje pelo coração — e como foi?',
  'Existe algo que você "apenas sente" mas não consegue explicar?',
  'O que acontece quando você ignora o que sua intuição diz?',
  // ── Palavras & Comunicação ────────────────────────────────────────────────
  'O que você disse hoje que gostaria de ter dito diferente?',
  'O que você não disse que deveria ter dito?',
  'Como as suas palavras afetaram alguém hoje?',
  'O que você expressou hoje com ações, não com palavras?',
  'Existe algo que você precisa escrever para processar?',
  'Como você fala sobre si mesma(o) quando ninguém está ouvindo?',
  'Qual foi a conversa mais honesta que você teve consigo mesma(o) hoje?',
  'O que você gostaria de ter a coragem de dizer em voz alta?',
  'Como o seu tom de voz refletiu o seu estado interno hoje?',
  'O que você comunicou com o seu silêncio?',
  // ── Leveza & Alegria ──────────────────────────────────────────────────────
  'O que te fez rir hoje?',
  'Quando foi a última vez que você brincou, de verdade?',
  'O que você faria hoje se não precisasse ser produtiva(o)?',
  'Qual é a versão mais leve de você que apareceu hoje?',
  'O que você fez por pura diversão, sem objetivo?',
  'Qual foi o momento mais leve do seu dia?',
  'O que te faz sentir que a vida é simples e boa?',
  'Existe algo que você leva a sério demais que poderia soltar?',
  'O que te faz bem sem nenhuma explicação racional?',
  'Como seria um dia vivido com mais leveza?',
  // ── Perdão & Soltura ──────────────────────────────────────────────────────
  'O que você está carregando em relação a alguém que poderia soltar?',
  'Como você se sentiu ao perdoar alguém — ou ao não conseguir?',
  'O que você precisa se perdoar para seguir em frente?',
  'Existe alguém que merece uma segunda chance da sua parte?',
  'O que o ressentimento está custando para você?',
  'Qual mágoa você está alimentando sem perceber?',
  'Como seria se você liberasse alguém da sua cobrança interna?',
  'O que você precisa encerrar em paz para começar algo novo?',
  'Existe algo que você fez que ainda não se perdoou completamente?',
  'O que você ganharia se soltasse a necessidade de ter razão?',
  // ── Vulnerabilidade & Coragem ─────────────────────────────────────────────
  'Quando foi a última vez que você pediu ajuda de verdade?',
  'O que você esconde de quase todo mundo?',
  'Qual é a coisa que mais te envergonha — que poderia te libertar se contada?',
  'O que você admitiu para si mesma(o) hoje que era difícil encarar?',
  'Como seria se você fosse completamente honesta(o) consigo mesma(o) agora?',
  'O que você faria agora se o medo não fosse um fator?',
  'Existe algo que você está esperando permissão para fazer — de quem?',
  'Qual foi o gesto de coragem mais silencioso que você teve hoje?',
  'O que te impede de mostrar quem você realmente é?',
  'Como seria um dia vivido com mais ousadia?',
  // ── Aceitação & Presença ──────────────────────────────────────────────────
  'O que você está tentando controlar que está fora do seu controle?',
  'O que você precisa aceitar para se sentir mais em paz?',
  'Existe algo que você não pode mudar e ainda está brigando com isso?',
  'Como seria deixar as coisas fluírem hoje, sem forçar?',
  'O que você está exigindo de si mesma(o) que ninguém mais exigiria?',
  'O que o presente momento está te oferecendo que você ainda não viu?',
  'Em quantos momentos hoje você esteve realmente presente?',
  'O que você perdeu por estar no piloto automático?',
  'Qual expectativa você precisaria soltar para se sentir mais leve?',
  'Como a diferença entre expectativa e realidade afetou seu humor hoje?',
  // ── Aprendizado & Curiosidade ─────────────────────────────────────────────
  'O que despertou sua curiosidade hoje?',
  'O que você não sabia ontem que sabe agora?',
  'Qual pergunta você está carregando sem resposta?',
  'O que você leu, ouviu ou viu que te fez pensar de forma diferente?',
  'Existe algo que você quer aprender mas ainda não começou?',
  'O que você ensinou (ou poderia ensinar) a alguém hoje?',
  'Qual foi a pergunta mais interessante que você se fez hoje?',
  'O que você gostaria de entender melhor sobre si mesma(o)?',
  'Qual conhecimento mudou a forma como você enxerga o mundo?',
  'O que você ainda tem muito a aprender sobre si mesma(o)?',
  // ── Comparação & Autenticidade ────────────────────────────────────────────
  'Quando você se comparou com alguém hoje? Como se sentiu?',
  'O que você está fingindo que não é para agradar alguém?',
  'Em que momentos você foi completamente você mesma(o) hoje?',
  'Onde você está performando em vez de vivendo?',
  'O que você colocaria nas redes se fosse completamente honesta(o)?',
  'O que você está fazendo para os outros que deveria estar fazendo para si?',
  'Existe um papel que você desempenha que não é mais verdadeiro?',
  'O que você admira nos outros que já existe dentro de você?',
  'Qual parte de você está esperando aprovação externa para existir?',
  'Como seria um dia vivido sem se comparar com ninguém?',
  // ── Transição & Incerteza ─────────────────────────────────────────────────
  'O que está em transição na sua vida agora?',
  'Como você lida com a incerteza — com medo ou com curiosidade?',
  'O que você está esperando que se estabilize para começar a viver?',
  'Qual mudança que você teme pode ser exatamente o que você precisa?',
  'Como você pode encontrar paz no meio do que ainda não está resolvido?',
  'O que está terminando na sua vida que merece um encerramento consciente?',
  'O que está começando que você ainda não reconheceu totalmente?',
  'Como você lida com as despedidas?',
  'O que você precisa encerrar para que algo novo possa começar?',
  'Qual capítulo da sua vida está sendo escrito agora?',
  // ── Prioridades & Escolhas ────────────────────────────────────────────────
  'O que você escolheu priorizar hoje — foi a escolha certa?',
  'O que ficou para depois que deveria ter sido primeiro?',
  'Como você poderia simplificar um aspecto da sua vida amanhã?',
  'O que você está complicando que poderia ser simples?',
  'Suas ações de hoje estavam alinhadas com o que você diz que é importante?',
  'O que você gastou energia hoje que não valia a pena?',
  'Onde você investiu o melhor de si hoje?',
  'O que você faria diferente se tivesse mais clareza sobre o que importa?',
  'Existe algo que você pode eliminar da sua vida sem perder nada?',
  'Como você quer usar o tempo que tem amanhã?',
  // ── Resiliência & Superação ───────────────────────────────────────────────
  'O que você superou hoje que não percebeu como conquista?',
  'Como você se levantou depois de um momento difícil hoje?',
  'O que a dificuldade de hoje está te preparando para enfrentar?',
  'Qual obstáculo recente te fez mais forte?',
  'O que você já sobreviveu que achava que não conseguiria?',
  'Como você está diferente de quem era antes das suas maiores dificuldades?',
  'O que você aprendeu sobre si mesma(o) em um momento de crise?',
  'Qual foi a última vez que você surpreendeu a si mesma(o) com a sua força?',
  'O que te ajuda a continuar quando tudo parece difícil?',
  'Como você quer reagir na próxima vez que encontrar um obstáculo?',
  // ── Criança Interior ──────────────────────────────────────────────────────
  'O que a criança que você foi gostaria de ver em você hoje?',
  'Qual alegria infantil você deixou de lado que pode resgatar?',
  'O que você precisava ouvir quando criança que pode se dizer agora?',
  'Em que momento hoje você foi completamente espontânea(o)?',
  'O que você ainda carrega da infância que já não te serve?',
  'Qual brincadeira da infância ainda traz leveza para você?',
  'O que a versão de você com 8 anos acharia de quem você é hoje?',
  'O que você perdeu na transição para a vida adulta que quer recuperar?',
  'Como você pode ser mais gentil com a criança que existe dentro de você?',
  'O que te fazia feliz sem motivo quando era pequena(o)?',
  // ── Impacto & Legado ──────────────────────────────────────────────────────
  'Qual impacto você teve na vida de alguém hoje, mesmo sem perceber?',
  'O que você quer que as pessoas sintam depois de estarem com você?',
  'Como você quer ser lembrada(o) pelas pessoas que convivem com você?',
  'O que você está fazendo hoje que ainda vai importar daqui a dez anos?',
  'Qual é a contribuição única que só você pode fazer para o mundo?',
  'O que você inspira nas pessoas sem saber?',
  'Qual exemplo você está dando com as suas ações de hoje?',
  'O que você fez hoje que foi além do que era esperado de você?',
  'Como a sua presença muda um ambiente quando você entra?',
  'O que você quer construir que dure mais do que você?',
  // ── Encerramento do Dia ───────────────────────────────────────────────────
  'Como você quer encerrar este dia?',
  'O que você vai carregar desta semana para a próxima?',
  'O que merecia ter mais tempo do que teve hoje?',
  'O que você está deixando incompleto que está bem ficar incompleto?',
  'Como você quer acordar amanhã — o que pode preparar esta noite?',
  'Olhando para o dia de hoje, o que você escolheria reviver?',
  'O que hoje te mostrou que você está crescendo?',
  'Qual foi a virada de chave mais sutil do seu dia?',
  'O que você vai levar deste dia para o resto da sua vida?',
  'Se hoje fosse o começo de algo novo, o que seria?',
  // ── Os 60 originais (ao final, para preservar a sequência de quem já os viu)
  'O que te surpreendeu hoje?',
  'Qual foi o momento mais presente do seu dia?',
  'O que você quer plantar na próxima semana?',
  'Pelo que você está grata(o) agora?',
  'O que você aprendeu sobre si mesma(o) hoje?',
  'Como você se sentiu ao desacelerar hoje?',
  'O que você quer deixar para trás dessa semana?',
  'Qual pensamento ficou mais tempo na sua cabeça hoje?',
  'O que deu certo hoje, mesmo que pequeno?',
  'Como seu corpo está se sentindo agora?',
  'O que você evitou hoje? Por quê?',
  'Qual foi a conversa mais significativa do seu dia?',
  'O que você fez hoje que te orgulha, mesmo que ninguém tenha percebido?',
  'Qual emoção apareceu com mais frequência hoje?',
  'Se hoje tivesse uma cor, qual seria? Por quê?',
  'O que você precisava ouvir hoje e ninguém disse?',
  'Tem algo que você postergou? O que está por trás disso?',
  'O que te deu energia hoje?',
  'O que drenou sua energia hoje?',
  'Qual foi o momento em que você se sentiu mais você mesma(o)?',
  'O que você gostaria de ter feito diferente hoje?',
  'Qual foi o maior obstáculo do seu dia — interno ou externo?',
  'Como você cuidou de si mesma(o) hoje?',
  'O que te conectou com outras pessoas hoje?',
  'Teve algum momento de silêncio hoje? Como foi?',
  'O que te fez sorrir hoje?',
  'Qual medo apareceu hoje, mesmo que de forma sutil?',
  'O que você está carregando que não é seu?',
  'O que você apreciou hoje que costuma ignorar?',
  'Como você descreveria seu estado emocional em uma frase?',
  'O que mudou em você nos últimos meses?',
  'Existe algo que você precisa perdoar — em si mesma(o) ou em alguém?',
  'Qual foi a decisão mais importante que você tomou hoje?',
  'O que você está com medo de admitir para si mesma(o)?',
  'Que tipo de pessoa você quer ser amanhã?',
  'O que você aprendeu com um erro recente?',
  'O que você está esperando que aconteça — e poderia criar você mesma(o)?',
  'Quem você é quando ninguém está olhando?',
  'O que o seu corpo tentou te dizer hoje?',
  'Qual é o padrão que você continua repetindo?',
  'O que você tolerou hoje que não deveria ter tolerado?',
  'Qual foi o momento mais honesto do seu dia?',
  'O que você quer que seja diferente daqui a 30 dias?',
  'Existe algo que você sabe que precisa mudar, mas está adiando?',
  'O que você aprendeu com uma situação difícil recente?',
  'Qual parte de você precisa de mais atenção agora?',
  'O que você faria diferente se soubesse que ia dar certo?',
  'Qual foi a coisa mais corajosa que você fez hoje?',
  'O que te conecta com o que realmente importa para você?',
  'Como você quer se sentir ao final desta semana?',
  'Existe alguém a quem você deveria agradecer?',
  'O que você está nutrido(a) — ou deixando murchar?',
  'O que você precisa soltar para avançar?',
  'Qual foi o momento de maior clareza hoje?',
  'O que você está criando com os seus pensamentos agora?',
  'Qual é a história que você conta sobre si mesma(o) que pode não ser mais verdade?',
  'O que você precisa pedir — para si mesmo(a) ou para alguém?',
  'Como seria seu dia ideal? O que está faltando para isso?',
  'O que você aprendeu com alguém diferente de você?',
  'Qual limite você precisa estabelecer (ou honrar) agora?',
];

// Mantido para compatibilidade com imports existentes
export const promptsVariados = {};

export function getPromptDoDia() {
  var agora = new Date();
  var inicio = new Date(agora.getFullYear(), 0, 0);
  var diaDoAno = Math.floor((agora - inicio) / 86400000);
  return PROMPTS_REFLEXAO[diaDoAno % PROMPTS_REFLEXAO.length];
}

export function getPromptForDate(dateStr) {
  const d = new Date(dateStr + 'T12:00:00');
  const inicio = new Date(d.getFullYear(), 0, 0);
  const diaDoAno = Math.floor((d - inicio) / 86400000);
  return PROMPTS_REFLEXAO[diaDoAno % PROMPTS_REFLEXAO.length];
}

export function getDatasDoDesafio(dataInicio, duracao) {
  const datas = [];
  for (let i = 0; i < duracao; i++) {
    const d = new Date(dataInicio + 'T00:00:00');
    d.setDate(d.getDate() + i);
    datas.push(d.toISOString().split('T')[0]);
  }
  return datas;
}

export function getDiaAtual(dataInicio, duracao) {
  const inicio = new Date(dataInicio + 'T00:00:00');
  const hoje = new Date();
  inicio.setHours(0, 0, 0, 0);
  hoje.setHours(0, 0, 0, 0);
  const diffDias = Math.floor((hoje - inicio) / (1000 * 60 * 60 * 24));
  const diaAtual = diffDias + 1;
  return {
    diaAtual: Math.min(diaAtual, duracao),
    concluido: diaAtual > duracao,
  };
}
